/**
 * Fehlercodes der Function als Sätze.
 *
 * Eine reine Abbildung, damit sich der Wortlaut prüfen lässt, ohne etwas zu
 * rendern. Und weil der Text durchkommen muss: beim Abschreiben der Anmeldung
 * war eine Vier-Zustands-Union einmal zu einem String eingeschrumpft, und auf
 * dem Bildschirm stand nur noch „Es hat nicht geklappt“.
 */
const MESSAGES: Record<string, string> = {
  already_invited:
    "Diese Adresse hat schon ein Profil – an dieser oder einer anderen Schule.",
  invalid_email: "Die E-Mail-Adresse sieht nicht wie eine Adresse aus.",
  invalid_school: "Die Schule wurde nicht richtig übergeben. Bitte Seite neu laden.",
  school_not_found: "Diese Schule gibt es nicht mehr.",
  name_missing: "Bitte einen Namen angeben.",
  platform_admin_only: "Dafür fehlt dem Konto das Plattformrecht.",
  not_signed_in: "Die Sitzung ist abgelaufen. Bitte neu anmelden.",
  invite_failed: "Die Einladung konnte nicht verschickt werden.",
  invite_timeout:
    "Der E-Mail-Dienst hat nicht geantwortet. Bitte versuchen Sie es in ein paar " +
    "Minuten noch einmal.",
  unexpected:
    "Da ist etwas schiefgegangen, womit niemand gerechnet hat. Bitte melden Sie " +
    "sich bei uns.",
  // Kann die App nicht auslösen – sie schickt POST. Der Wächter nimmt die
  // Ausrede nicht an: „eigentlich nicht“ ist kein Satz für den Bildschirm.
  method_not_allowed: "Die Einladung wurde falsch angefragt. Bitte neu laden.",
  email_rate_limit:
    "Der E-Mail-Dienst ist am Limit. In etwa einer Stunde noch einmal versuchen – " +
    "oder für diese Umgebung eigenes SMTP einrichten.",
  profile_failed: "Das Konto entstand, das Profil nicht. Bitte den Vorgang wiederholen.",
};

/**
 * @param status HTTP-Status der Antwort, falls bekannt.
 *
 * Er steht im Rückfalltext, und zwar aus Erfahrung: „Die Einladung ist
 * fehlgeschlagen“ hat einmal zwei Umwege gekostet, weil der eigentliche Grund
 * (Postfachlimit, HTTP 429) nur im Antwortkörper stand. Wer die Meldung liest,
 * hat kein Werkzeug zur Hand – die Zahl ist das Mindeste, womit sich nachfragen
 * lässt.
 */
export function inviteErrorText(code: string, status?: number): string {
  const known = MESSAGES[code];
  if (known) return known;

  // Der unbekannte Code steht mit im Text – wie in der Verwaltung. Ohne ihn
  // bleibt von einem Fehlschlag nur „fehlgeschlagen“, und die Suche nach der
  // Ursache fängt bei null an.
  const hinweis = status === undefined ? code : `${code}, HTTP ${status}`;
  return `Die Einladung ist fehlgeschlagen (${hinweis}).`;
}
